import { GraphQLExecutor } from '@app/model/_common/service/GraphQLExecutor';
import {
	FIND_COMPETITORS_GROUP_HOTELS_QUERY,
	FIND_HOTELS_AROUND_COMPANY_HOTEL_MAIN_HOTEL_QUERY, FIND_HOTELS_AROUND_COORDINATES_MUTATION,
} from '@app/model/flexi_sets/service/FlexiSetsGraphQLQueries';
import SearchHotelsFilterInput from '@app/model/flexi_sets/input/SearchHotelsFilterInput';
import SearchHotelWithinRadiusResult from '@app/model/flexi_sets/SearchHotelWithinRadiusResult';
import Coordinates from '@app/model/hotel/Coordinates';


export default class FlexiSetsService {

	public static findHotelsAroundCompanyHotelMainHotel(filter: SearchHotelsFilterInput) {
		return GraphQLExecutor.execute<SearchHotelWithinRadiusResult[]>(FIND_HOTELS_AROUND_COMPANY_HOTEL_MAIN_HOTEL_QUERY, { filter });
	}

	public static findHotelsAroundCoordinates(filter: SearchHotelsFilterInput) {
		return GraphQLExecutor.execute<SearchHotelWithinRadiusResult[]>(FIND_HOTELS_AROUND_COORDINATES_MUTATION, { filter });
	}

	public static findCompetitorsGroupHotels(companyHotelId: number, competitorsGroupId: number) {
		return GraphQLExecutor.execute<SearchHotelWithinRadiusResult[]>(FIND_COMPETITORS_GROUP_HOTELS_QUERY, {
			companyHotelId,
			competitorsGroupId,
		});
	}
}